module.exports = __webpack_public_path__ + "static/media/news5-3.0e2410a4.jpg";